import React from "react";

export default function RpBasedPane({
    rpEntries,
    selectedRpIds,
    onToggleRp,
    copiesPerPallet,
    onCopiesChange,
    palletPreview,
}) {
    return (
        <div className="space-y-3" data-testid="lt-rp-pane">
            {rpEntries.length === 0 ? (
                <div className="text-sm border border-amber-200 bg-amber-50 text-amber-900 rounded-sm px-3 py-2">
                    No RP entries yet — use the Manual tab to print tags before
                    production, or record production first.
                </div>
            ) : (
                <>
                    <div className="text-xs text-gray-600">
                        Select RP entries to include. One page per pallet (× copies).
                    </div>
                    <div className="border border-gray-200 rounded-sm overflow-hidden">
                        <table className="odr-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>RP #</th>
                                    <th>Date</th>
                                    <th className="text-right">Pallets</th>
                                    <th className="text-right">Units</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rpEntries.map((rp) => (
                                    <tr key={rp.id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedRpIds.has(rp.id)}
                                                onChange={() => onToggleRp(rp.id)}
                                                data-testid={`lt-rp-toggle-${rp.rp_number}`}
                                            />
                                        </td>
                                        <td className="odr-mono text-xs">{rp.rp_number}</td>
                                        <td className="text-xs">{rp.production_date}</td>
                                        <td className="text-right odr-mono">
                                            {rp.total_pallets}
                                        </td>
                                        <td className="text-right odr-mono">
                                            {Number(rp.total_units).toLocaleString()}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="flex items-center gap-3">
                        <label className="text-xs font-semibold uppercase tracking-wider text-gray-600">
                            Copies per pallet
                        </label>
                        <input
                            type="number"
                            min="1"
                            max="10"
                            value={copiesPerPallet}
                            onChange={(e) => onCopiesChange(Number(e.target.value) || 1)}
                            className="odr-input w-20 rounded-sm border border-gray-300 px-3 text-sm odr-mono"
                            data-testid="lt-copies"
                        />
                    </div>
                    <div className="text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-sm px-3 py-2">
                        Will generate{" "}
                        <span className="font-semibold odr-mono">
                            {palletPreview.pallets}
                        </span>{" "}
                        page(s) (={palletPreview.base_pallets} pallet(s) ×{" "}
                        {copiesPerPallet} copy/copies).
                    </div>
                </>
            )}
        </div>
    );
}
